export const DataHooks = {
  Root: 'Toast.Root',
} as const;
